/** Muted note when the API left older or dismissed models out of the lists. */
const HiddenCandidatesNote = ({ count }: { count: number | undefined }) =>
  typeof count === "number" && count > 0 ? (
    <p className="text-xs text-muted-foreground">
      {count} older or dismissed {count === 1 ? "model is" : "models are"} hidden.
    </p>
  ) : null;

export default HiddenCandidatesNote;
